import React, {useState, useEffect, useLayoutEffect} from 'react';
import {useNavigate} from 'react-router-dom';
import _ from 'lodash';
import jQ from 'jquery';

import {MaxisBusinessLogo, LoginLogo, SearchIconBlack, CloseIconGray, OrderTrackerLogo} from '../../styles/icons';
import SideBar from './block/SideBar';
import SearchMenu from './block/SearchMenu';
import DropDownMenu from '../DropDownMenu';
import SearchBar from './block/SearchBar';
import Config from '../../utils/Configuration';
import Utility from '../../utils/Helper';
import {pagePath} from '../../RouteConfig';
import {headerUrl} from './Header.Config';

export default function Header(props) {
    const {
        intl,
        i18nLabels,
        screenName,
        lastSearch,
        searchString,
        getSearchResults,
        trendingSearches,
        searchPromotions,
        updateSearchString,
        getSuggestedSearches,
        selectedCategory,
        getHeader,
        getTrendingKeywords,
        getSearchPromotions,
        headerFooter
    } = props;
    const disableTabs = true;

    const [isScrolled, setScrolled] = useState(false);
    const [showSearch, setShowSearch] = useState(false);
    const [dropDownToggle, setDropDownToggle] = useState(false);
    const navigate = useNavigate();

    const topHeaderLeftGroup = [
        {
            text: intl.messages.consumerLabel,
            url: headerUrl.consumerLink,
            style: 'maxis-bold top-header-inactive'
        },
        {
            text: intl.messages.businessLabel,
            url: headerUrl.businessSMELink,
            style: 'maxis-bold top-header-active'
        },
        {
            text: intl.messages.hotlinkLabel,
            url: headerUrl.hotlinkLink,
            style: 'maxis-bold top-header-inactive'
        }
    ];
    const topHeaderRightGroup = [
        {
            text: intl.messages.orderTrackerLabel,
            logo: <OrderTrackerLogo width={15} height={18} />,
            url: pagePath.orderTracking
        },
        {text: intl.messages.mbhLoginLabel, logo: <LoginLogo width={15} height={18} />, url: headerUrl.businessHubLink}
    ];

    const bottomHeaderGroup = [
        {title: intl.messages.broadbandLabel, style: 'maxis-bold text-dark-blue-3'},
        {
            title: intl.messages.mobilePlansLabel,
            style: 'maxis-bold text-blue-grey' + (disableTabs ? ' cursor-not-allowed' : '')
        },
        {
            title: intl.messages.devicesLabel,
            style: 'maxis-bold text-blue-grey' + (disableTabs ? ' cursor-not-allowed' : '')
        }
    ];

    const businessDropdownOption = [
        {
            label: intl.messages.smeLabel,
            url: headerUrl.businessSMELink,
            mobileStyle: 'selection-box-green text-dark-blue-2 maxis-bold'
        },
        {
            label: intl.messages.corporateLabel,
            url: headerUrl.businessCorporateLink,
            mobileStyle: 'selection-box-grey text-grey-three maxis-bold'
        }
    ];

    const showSolrSearch = Config.solrSearch.enable;

    const searchMenuProps = {
        intl,
        lastSearch,
        screenName,
        showSearch,
        searchString,
        setShowSearch,
        getSearchResults,
        trendingSearches,
        searchPromotions,
        updateSearchString,
        getSuggestedSearches,
        selectedCategory,
        navigate
    };

    const onSearchClick = () => {
        document.body.addEventListener('mousedown', handleOutsideSearchClick);
        setShowSearch(true);
        setDropDownToggle(false);
    };

    const toggleDropDown = () => {
        setDropDownToggle((status) => !status);
    };

    const handleScroll = () => {
        if (window.scrollY > 1) {
            setScrolled(true);
        } else {
            setScrolled(false);
        }
    };

    const handleSubmitSearch = (event) => {
        event.preventDefault();
        setShowSearch(false);
        if (screenName !== Config.pageName.solrSR) {
            Utility.navigateTo(pagePath.solrSearchResultUrl, navigate);
        } else {
            getSearchResults(searchString);
            document.getElementById('searchInput') && document.getElementById('searchInput').blur();
        }
    };

    const clickBottomHeader = (nav) => {
        Utility.navigateTo(nav.path, navigate);
    };

    const onClickTopHeader = (link) => {
        Utility.navigateTo(link, navigate);
    };

    const handleOutsideSearchClick = (event) => {
        if (
            event &&
            !jQ(event.target).closest('.searchMenu').length &&
            !jQ(event.target).closest('.searchInput').length &&
            !jQ(event.target).closest('.searchBar').length
        ) {
            document.body.removeEventListener('click', handleOutsideSearchClick, false);
            setShowSearch(false);
        }
    };

    useEffect(() => {
        window.addEventListener('scroll', handleScroll, {passive: true});
        _.isEmpty(headerFooter) && getHeader();
        _.isEmpty(trendingSearches) && getTrendingKeywords();
        _.isEmpty(searchPromotions) && getSearchPromotions();

        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useLayoutEffect(() => {
        if (showSearch) {
            document.body.style.overflow = 'hidden';
            document.body.style.height = '100%';
        } else {
            document.body.style.overflow = 'auto';
            document.body.style.height = 'auto';
        }
    }, [showSearch]);

    return (
        <>
            <div className='header'>
                <div className='d-none d-lg-block'>
                    <div className='top-header'>
                        <div className='container'>
                            <div className='top-header row align-items-center'>
                                <div className='d-flex flex-row col-6 gap-30px'>
                                    <div
                                        className='maxis-bold top-header-inactive'
                                        onClick={() => onClickTopHeader(headerUrl.consumerLink)}
                                    >
                                        {intl.messages.consumerLabel}
                                    </div>
                                    <DropDownMenu
                                        title={intl.messages.businessSMELabel}
                                        dropDownOptions={businessDropdownOption}
                                        dropDownToggle={dropDownToggle}
                                        toggleDropDown={toggleDropDown}
                                        onClickOption={onClickTopHeader}
                                    />
                                    <div
                                        className='maxis-bold top-header-inactive'
                                        onClick={() => onClickTopHeader(headerUrl.hotlinkLink)}
                                    >
                                        {intl.messages.hotlinkLabel}
                                    </div>
                                </div>
                                <div className='d-flex flex-row justify-content-end col-6 gap-30px'>
                                    {topHeaderRightGroup.map((group, index) => {
                                        return (
                                            <div
                                                className='text-dark-blue-2 maxis-bold cursor-pointer'
                                                onClick={() => onClickTopHeader(group.url)}
                                                key={`${index}_${group.text}`}
                                            >
                                                <span className='me-1 align-text-bottom'>{group.logo}</span>
                                                {group.text}
                                            </div>
                                        );
                                    })}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className={`bottom-header ${isScrolled && 'scrolled-header'}`}>
                        <div className='container h-100'>
                            <div className='row align-items-center h-100'>
                                <div className='d-flex flex-row col-8 gap-30px'>
                                    {(bottomHeaderGroup || []).map((group, index) => {
                                        return (
                                            <div
                                                className={`${
                                                    isScrolled ? '' : 'py-3'
                                                } bottom-header-text text-uppercase ${group.style}`}
                                                onClick={disableTabs ? undefined : () => clickBottomHeader(group)}
                                                key={`${index}_${group.title}`}
                                            >
                                                {group.title}
                                            </div>
                                        );
                                    })}
                                    {showSolrSearch && (
                                        <div
                                            className={`headerSearch ${showSearch ? 'searchActive' : ''} ${
                                                isScrolled ? '' : 'py-3'
                                            }`}
                                        >
                                            <form className='search-form' onSubmit={handleSubmitSearch}>
                                                <SearchIconBlack />

                                                <input
                                                    id='searchInput'
                                                    type='search'
                                                    value={searchString}
                                                    className='fs-14 maxis-semiBold text-gunmetal pl-1 searchInput search-form'
                                                    autoComplete='off'
                                                    spellCheck={false}
                                                    placeholder={intl.messages.searchLabel}
                                                    onClick={onSearchClick}
                                                    onChange={(e) => {
                                                        updateSearchString(e.target.value);
                                                    }}
                                                />

                                                <CloseIconGray
                                                    className={`closeSearch cursor-pointer ${
                                                        showSearch ? '' : 'd-none'
                                                    }`}
                                                    onClick={() => setShowSearch(false)}
                                                />
                                            </form>
                                        </div>
                                    )}
                                </div>
                                <div className={`d-flex flex-row justify-content-end col-4 py-1`}>
                                    <MaxisBusinessLogo width={isScrolled ? 270 : 315} className='maxis-logo' />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div id='blurOverlay' className={`${showSearch ? '' : 'd-none'}`} />
                <div className='d-block d-lg-none'>
                    <SideBar
                        intl={intl}
                        headerDetails={bottomHeaderGroup}
                        topHeaderRightGroup={topHeaderRightGroup}
                        topHeaderLeftGroup={topHeaderLeftGroup}
                        selectionOption={businessDropdownOption}
                        onClickTopHeader={onClickTopHeader}
                        onSearchClick={onSearchClick}
                        showSolrSearch={showSolrSearch}
                    />
                    {showSearch && (
                        <SearchBar
                            intl={intl}
                            i18nLabels={i18nLabels}
                            searchString={searchString}
                            setShowSearch={setShowSearch}
                            getSearchResults={getSearchResults}
                            updateSearchString={updateSearchString}
                            selectedCategory={selectedCategory}
                            screenName={screenName}
                            navigate={navigate}
                        />
                    )}
                </div>
                <SearchMenu {...searchMenuProps} />
            </div>
        </>
    );
}
